import { Box } from '@dtx-company/shared-components/src'
import { ProgressBarProps } from '../../../types/progress-bar.types'
import React from 'react'
import styled from 'styled-components'

const StyledBox = styled(Box)`
  transition: width 0.25s ease-out;
`

export const ProgressBar = ({
  percentage,
  barProps,
  height,
  ...rest
}: ProgressBarProps): JSX.Element => (
  <Box backgroundColor="secondary.backgroundDark" height={height ?? '10px'} width="100%" {...rest}>
    <StyledBox
      data-testid="progress-bar"
      width={percentage}
      backgroundColor="primary.flowBlue"
      height="100%"
      {...barProps}
    />
  </Box>
)
